// Switch icon implementation to react-icons components.
// We keep the same reference keys so the rest of the app (MenuService etc.) stays unchanged.
import { WeclappIcon } from "./Icons/WeclappIcon.js";

// Prefer Phosphor icons (react-icons/pi)
import {
  PiGauge,
  PiFiles,
  PiEnvelopeSimple,
  PiUser,
  PiUsers,
  PiGear,
  PiCalendar,
  PiDownloadSimple,
  PiUploadSimple,
  PiFileText,
  PiKey,
  PiDetective,
  PiCurrencyEur,
  PiSprayBottle,PiArrowsDownUp,PiWarehouse,PiMegaphone,PiHeadset,PiChartLineUp,PiTruck
} from "react-icons/pi";
import {SprayIcon} from "./Icons/SprayIcon.js";

const icons = {
  // core sections
  dashboard: PiGauge,
  products: SprayIcon,
  orders: PiFileText,
  mail: PiEnvelopeSimple,
  import: PiDownloadSimple,
  export: PiUploadSimple,

  // admin/settings
  roles: PiUser,
  activitylogs: PiDetective,
  users: PiUsers,
  settings: PiGear,
  oauth: PiKey,

  // stock
  stock: PiWarehouse,

  // weclapp
  weclapp: WeclappIcon,
  weclappPayment: PiCurrencyEur,
    weclappTransfer: PiArrowsDownUp,

  // campaigns
  campaigns: PiMegaphone,

  // support
  support: PiHeadset,

  // Nutzungsstatistik (nur Superadmin bzw. wer das Recht bekommen hat)
  nutzung: PiChartLineUp,

  // Lieferant Cosmos (geschützter Bereich, F6 - niemandem zugewiesen)
  cosmos: PiTruck,

  // Dokumente (geschützter Bereich, späteres Intranet)
  documents: PiFiles,

  // keep a few generics for potential reuse
  calendar: PiCalendar,
};

export default icons;
